export default __webpack_public_path__ + "static/media/sponsor-video-one.4799a3db.mp4";